document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname === '/' || window.location.pathname === '/pages/nosotros' ) {
    return; // Detiene la ejecución si es el home
  }
  // Selección del formulario y elementos clave
  const filterForm = document.getElementById('FacetFiltersFormMobile');
  const clearButtons = filterForm.querySelectorAll('.mobile-facets__clear'); // Botones Clear
  const detailsElements = filterForm.querySelectorAll('details');
  const checkboxes = filterForm.querySelectorAll('input[type="checkbox"]');
  const tallaCheckboxes = filterForm.querySelectorAll('input[name="filter.v.option.talla"]'); // Filtro específico de tallas

  // Aplicar filtros automáticamente al cambiar un checkbox
  checkboxes.forEach(checkbox => {
    checkbox.addEventListener('change', () => {
      const params = new URLSearchParams(new FormData(filterForm));
      const baseUrl = window.location.pathname;

      // Ajustar la consulta: ordenar por los más recientes
      params.set('sort_by', 'created-descending'); // Ordenar por productos más recientes

      // Verificar si se seleccionó alguna talla y agregar disponibilidad solo en ese caso
      const tallaSelected = Array.from(tallaCheckboxes).some(tallaCheckbox => tallaCheckbox.checked);
      if (tallaSelected) {
        params.set('filter.v.availability', '1'); // Usar `filter.v.availability=1` para tallas disponibles
      }

      // Construir la URL final
      let newUrl = baseUrl;
      if (params.toString()) {
        newUrl += `?${params.toString()}`;
      }

      // Redirigir a la URL actualizada
      window.location.href = newUrl;
    });
  });

  // Manejo del botón Clear para resetear los filtros
  clearButtons.forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const clearUrl = button.getAttribute('href');

      // Redirige a la URL base sin filtros
      window.location.href = clearUrl;
    });
  });

  // Manejo de apertura y cierre de los detalles (accesibilidad y estilo)
  detailsElements.forEach(detail => {
    const summary = detail.querySelector('summary');

    summary.addEventListener('click', () => {
      // Cierra otros <details> excepto el actual
      detailsElements.forEach(d => {
        if (d !== detail) {
          d.removeAttribute('open');
        }
      });
    });
  });

  // Opcional: Scroll suave para botones y enlaces (mejora UX)
  const smoothScroll = () => {
    const scrollLinks = filterForm.querySelectorAll('a[href^="#"], button');
    scrollLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        const targetId = link.getAttribute('href');
        if (targetId && document.querySelector(targetId)) {
          event.preventDefault();
          document.querySelector(targetId).scrollIntoView({ behavior: 'smooth' });
        }
      });
    });
  };
  smoothScroll();
});

// Script optimizado para filtros de género en Shopify Mobile Facets
(function() {
  'use strict';

  let isInitialized = false;
  
  function initGenderFilter() {
    // Evitar múltiples inicializaciones
    if (isInitialized) return;
    
    const hombreCheckbox = document.querySelector('#Filter-filter\\.p\\.m\\.custom\\.genero-mobile-1');
    const mujerCheckbox = document.querySelector('#Filter-filter\\.p\\.m\\.custom\\.genero-mobile-2');
    const unisexCheckbox = document.querySelector('#Filter-filter\\.p\\.m\\.custom\\.genero-mobile-3');
    
    // Verificar que los elementos existan
    if (!hombreCheckbox || !mujerCheckbox || !unisexCheckbox) {
      console.warn('Filtros de género no encontrados, reintentando...');
      return false;
    }

    // Función para disparar eventos de Shopify
    function triggerChange(element) {
      // Evento change estándar
      element.dispatchEvent(new Event('change', { bubbles: true }));
      
      // Evento input para mayor compatibilidad
      element.dispatchEvent(new Event('input', { bubbles: true }));
      
      // Trigger del form parent si existe
      const form = element.closest('form');
      if (form) {
        form.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Variables para controlar el estado
    let userChangedUnisex = false;
    let processingChange = false;

    function updateUnisex() {
      // Evitar loops infinitos
      if (processingChange) return;
      processingChange = true;

      const isHombreChecked = hombreCheckbox.checked;
      const isMujerChecked = mujerCheckbox.checked;

      try {
        // Si se selecciona Hombre o Mujer, activar Unisex automáticamente
        if ((isHombreChecked || isMujerChecked) && !unisexCheckbox.checked && !userChangedUnisex) {
          unisexCheckbox.checked = true;
          triggerChange(unisexCheckbox);
        }
        // Si se deseleccionan ambos y el usuario no cambió Unisex manualmente, desactivarlo
        else if (!isHombreChecked && !isMujerChecked && unisexCheckbox.checked && !userChangedUnisex) {
          unisexCheckbox.checked = false;
          triggerChange(unisexCheckbox);
          // Reset del flag después de la acción automática
          setTimeout(() => { userChangedUnisex = false; }, 100);
        }
      } finally {
        processingChange = false;
      }
    }

    // Event listeners para hombre y mujer
    hombreCheckbox.addEventListener('change', updateUnisex);
    mujerCheckbox.addEventListener('change', updateUnisex);

    // Event listener para unisex para detectar cambios manuales
    unisexCheckbox.addEventListener('change', function(e) {
      // Si es un evento trusted (click del usuario), marcar como cambio manual
      if (e.isTrusted && !processingChange) {
        userChangedUnisex = true;
        // Reset del flag después de 3 segundos
        setTimeout(() => { userChangedUnisex = false; }, 3000);
      }
    });

    // También detectar clicks directos en los labels
    [hombreCheckbox, mujerCheckbox].forEach(checkbox => {
      const label = checkbox.closest('label');
      if (label) {
        label.addEventListener('click', () => {
          // Pequeño delay para que el checkbox se actualice primero
          setTimeout(updateUnisex, 10);
        });
      }
    });

    isInitialized = true;
    console.log('Filtro de género inicializado correctamente');
    return true;
  }

  function resetAndReinit() {
    isInitialized = false;
    setTimeout(initGenderFilter, 100);
  }

  // Inicialización
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initGenderFilter);
    } else {
      initGenderFilter();
    }

    // Reinicializar en cambios de Shopify
    document.addEventListener('shopify:section:load', resetAndReinit);
    
    // Observer para detectar cuando se cargan los filtros dinámicamente
    if (window.MutationObserver) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          // Si se añaden nuevos elementos con los IDs que buscamos
          if (mutation.type === 'childList') {
            const addedNodes = Array.from(mutation.addedNodes);
            const hasGenderFilter = addedNodes.some(node => 
              node.nodeType === 1 && 
              (node.querySelector && node.querySelector('[id*="genero-mobile"]'))
            );
            
            if (hasGenderFilter && !isInitialized) {
              setTimeout(initGenderFilter, 200);
            }
          }
        });
      });

      // Observar cambios en el body
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  // Función global para debugging
  window.debugGenderFilter = function() {
    console.log('Estado del filtro:', {
      hombre: document.querySelector('#Filter-filter\\.p\\.m\\.custom\\.genero-mobile-1')?.checked,
      mujer: document.querySelector('#Filter-filter\\.p\\.m\\.custom\\.genero-mobile-2')?.checked,
      unisex: document.querySelector('#Filter-filter\\.p\\.m\\.custom\\.genero-mobile-3')?.checked,
      initialized: isInitialized
    });
  };

  // Función global para reinicializar manualmente
  window.reinitGenderFilter = resetAndReinit;

  // Inicializar
  init();

})();